
















import { Vue, Component } from "vue-property-decorator";
import { api } from '../../api';
import { validEmail } from '../../utils/validation';

@Component
export default class extends Vue {
  email = ''
  name = ''
  body = ''

  validateAlways = false

  get ok() {
    return this.emailErrors.length + this.nameErrors.length + this.bodyErrors.length === 0
  }

  get emailErrors() {
    return [!validEmail(this.email) && this.$t('invalid_format')].filter((e) => e)
  }

  get nameErrors() {
    return [this.name.length === 0 && this.$t('your_name_cannot_be_empty')].filter((e) => e)
  }

  get bodyErrors() {
    return [this.body.length === 0 && this.$t('body_cannot_be_empty')].filter((e) => e)
  }

  async submit() {
    if (!this.ok) {
      (this.$refs.dialog as any).shake(() => this.validateAlways = true)
      return
    }
    const axios = api.default
    const { email, name, body } = this
    const res = await axios.post('../api/v1/inquiry', { email, name, body })
    alert(this.$t('done', { to: this.email }))
    this.$router.go(-1)
  }

  mounted() {
    (this.$refs.email as any).focus()
  }

  back() {
    this.$router.back()
  }
}
